var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapAllDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1374",
    "data-name": "Grupo 1374",
    transform: "translate(-523 -2851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1369",
    "data-name": "Grupo 1369",
    transform: "translate(65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_980",
    "data-name": "Caminho 980",
    d: "M0,0H27V27H0Z",
    transform: "translate(458 2851)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_981",
    "data-name": "Caminho 981",
    d: "M24.881,3l-.2.038L18,5.626,10.5,3,3.45,5.376a.63.63,0,0,0-.45.6V24.881a.619.619,0,0,0,.625.625l.2-.038L10.5,22.881,18,25.506l7.052-2.376a.63.63,0,0,0,.45-.6V3.625A.619.619,0,0,0,24.881,3ZM18,23.006l-7.5-2.638V5.5L18,8.139Z",
    transform: "translate(457.004 2850.004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapAllDashboard);
export default __webpack_public_path__ + "static/media/map-all-dashboard.0f83b36ea5870a33da37835695850575.svg";
export { ForwardRef as ReactComponent };